import { render, staticRenderFns } from "./EmployeeToDoList.vue?vue&type=template&id=72efc30a&"
import script from "./EmployeeToDoList.vue?vue&type=script&lang=js&"
export * from "./EmployeeToDoList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports